import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';
import { CustomConfirmDialogueComponent } from '../custom-confirm-dialogue/custom-confirm-dialogue.component';
@Component({
  selector: 'app-admin-search',
  templateUrl: './admin-search.component.html',
  styleUrls: ['./admin-search.component.scss']
})
export class AdminSearchComponent implements OnInit, OnChanges {

  agentSearchForm!: UntypedFormGroup;
  @Output() onSearchEmit = new EventEmitter();
  @Output() onClearEmit = new EventEmitter();
  @Input() branchAdminOfficeList: any = [];
  searchByOffice = true;
  filteredOfficeList: any;
  filteredAgentList: any;
  @Input() isBranchAdminUser: any;
  officeList: any = [];
  agentList: any = [];
  lastSearchedOffice: any;
  lastSearchedOfficeFlag: any;
  searchedAgent = false;
  delegateAgentList: any = [];
  @ViewChild('confirmCancelModal', { static: true })
  public confirmCancelModal: CustomConfirmDialogueComponent | any;
  selectedAgent = false;
  @Input() isMobileDevice: any;
  @Input() officeManagerAgentSearch: any;
  @Input() officeManagerOfficeList: any = [];
  disableClrBtn: boolean = true;
  virtualLoading: boolean = false;
  isDelegateUser: boolean = false;
  constructor(private formBuilder: UntypedFormBuilder, private commonService: CommonService,
    private spinner: NgxSpinnerService) {
    // blank constructor
  }

  ngOnInit(): void {
    this.initializeSearchAgentForm(); 
  }

  ngOnChanges() {    
    this.isDelegateUser = this.commonService.getIsDelegateLoggedIn();
    let lastSearchValue = this.commonService.getLastSearchAgentDetails();
    if (this.isMobileDevice && lastSearchValue) {
      this.lastSearchedOfficeFlag = true;
      if ((this.isBranchAdminUser && this.branchAdminOfficeList.length === 1) ||
        (this.officeManagerAgentSearch && this.officeManagerOfficeList.length === 1)) {
        this.searchByOffice = false;
        if (!this.isDelegateUser)
          this.getAgentList('');
      } else {
        if (Object.keys(lastSearchValue.officeName).length === 0) {
          this.searchByOffice = false;
          if (!this.isDelegateUser)
            this.getAgentList('');
        }
      }
    } else {
      this.lastSearchedOfficeFlag = false;
    }
    if ((this.isBranchAdminUser && this.branchAdminOfficeList.length === 1) ||
      (this.officeManagerAgentSearch && this.officeManagerOfficeList.length === 1)) {
      this.searchByOffice = false;
      if (!this.lastSearchedOfficeFlag && !this.isDelegateUser) {
        this.getAgentList('')
      }
    }
    this.initializeSearchAgentForm();
    if (this.searchByOffice && !this.isDelegateUser) {
      this.getOfficelist();
    }
    if (this.isDelegateUser)
      this.getDelegateOfficeAgentlist();      
  }

  /** get office list based on logged in user */
  getDelegateOfficeAgentlist() {
    this.spinner.show();
    let userName = this.commonService.getDelegateUserInfo()?.Email_Address;
    this.commonService.getDelegateOfficeAgents(userName).subscribe((res: any) => {
      this.officeList = [];
      res.delegateAgents.forEach((element: any) => {
        if (this.officeList.filter((a: any) => a.id === element.agentPrimaryPCNumber).length === 0)
          this.officeList.push({ 'id': element.agentPrimaryPCNumber, 'value': element.officeName, 'fieldValue': `${element.agentPrimaryPCNumber} - ${element.officeName}` });
        this.delegateAgentList.push({ 'id': element.agentNumber, 'value': element.agentName, 'pcnumber': element.agentPrimaryPCNumber });
      });      
      this.spinner.hide();
      this.setSearchedAgent();      
    }, (_err: any) => {
      this.spinner.hide();
    })
  }

  /**Set default searched/selected agent */
  setSearchedAgent()
  {
    let searchedAgentData = sessionStorage.getItem('adminSearchData'); 
    if(searchedAgentData !== null)
    {     
      searchedAgentData = JSON.parse(searchedAgentData); 
      this.commonService.setLastAgentSearchDetails(searchedAgentData);
      let agentData = this.commonService.getLastSearchAgentDetails();
      this.commonService.setAgentNumber(agentData?.agentName?.id?.trimEnd());
      this.lastSearchedOfficeFlag = true;
     }

    let agentNumber: string;
    if(!this.lastSearchedOfficeFlag){
      agentNumber = this.commonService.getDelegateUserInfo()?.Agent_Number;
      if(this.isMobileDevice)
      {
        this.selectedAgent = true;
        this.disableClrBtn = false;        
      }
    }
    else {
      let lastSearch = this.commonService.getLastSearchAgentDetails();
      agentNumber = lastSearch?.agentName?.id;
      if (Object.keys(lastSearch.officeName).length === 0)
        this.searchByOffice = false;
    }
    if(agentNumber !== '')
    {
      let selectedAgent = this.delegateAgentList.filter((a: any) => a.id === agentNumber.toString());
      let selectedOffice = this.officeList.filter((a: any) => a.id === selectedAgent[0]?.pcnumber);
      this.agentSearchForm.controls['agentName'].setValue(selectedAgent[0]);
      if(this.searchByOffice)
        this.agentSearchForm.controls['officeName'].setValue(selectedOffice[0]);      
      
      if(searchedAgentData !== null  && !this.commonService.responsiveAdminSearchClicked && this.lastSearchedOfficeFlag)
      { 
        this.searchedAgent = true;
        this.searchByOffice = this.commonService.getLastSearchAgentDetails()?.officeName?.id !== undefined;
        this.onSearchEmit.emit(this.commonService.getLastSearchAgentDetails());
        let redirectUrl = sessionStorage.getItem('currentUrl');
        redirectUrl = redirectUrl?redirectUrl:'/portal/personal-info/photos';
        this.commonService.redirectToNewPage(redirectUrl);        
      }
      else {
        const data = this.agentSearchForm.value;
        sessionStorage.setItem('adminSearchData', JSON.stringify(data));
        this.commonService.setAgentNumber(data?.agentName?.id?.trimEnd());
        this.commonService.setLastAgentSearchDetails(data);
        this.searchedAgent = true;
        if (!this.isMobileDevice) {        
          this.onSearchEmit.emit(data);
        }
      }
    }
  }

  /** get office list based on logged in user */
  getOfficelist() {
    let searchedAgentData = sessionStorage.getItem('adminSearchData'); 
    if(searchedAgentData !== null)
    {     
      searchedAgentData = JSON.parse(searchedAgentData); 
      this.commonService.setLastAgentSearchDetails(searchedAgentData);
      let agentData = this.commonService.getLastSearchAgentDetails();
      this.commonService.setAgentNumber(agentData?.agentName?.id?.trimEnd());
      this.lastSearchedOfficeFlag = true;
     }

    let param = `UserName=${this.commonService.getSavedUserInfo()?.userPrincipalName},SiteUserTyp=${this.commonService.getUserRoleObjr()?.siteUserType}`;
    this.spinner.show();
    this.commonService.getOfficeNumer(param).subscribe((res: any) => {
      this.officeList = res.body;
      this.officeList?.forEach((element: any) => {
        element['fieldValue'] = `${element.id} - ${element.value}`
      });
      if (this.lastSearchedOfficeFlag) {
        this.agentSearchForm.controls['officeName'].setValue(this.commonService.getLastSearchAgentDetails()?.officeName);
        this.getAgentList(this.commonService.getLastSearchAgentDetails()?.officeName);        
      } else {
        this.spinner.hide();
      }

    }, (_err: any) => {
      this.spinner.hide();
    })
  }

  /** get agent list based on office  */
  getAgentList(officeInfo: any) {
    if (this.isDelegateUser) {
      if (officeInfo === ''){
        this.agentList = this.delegateAgentList;
      }
      else this.agentList = this.delegateAgentList.filter((a: any) => a.pcnumber === officeInfo?.value.id);
      
      return this.agentList;
    }
    let param = '';
    if (!officeInfo || officeInfo === '' || Object.keys(officeInfo).length === 0) {
      param = `UserName=${this.commonService.getSavedUserInfo()?.userPrincipalName}`;
      this.spinner.show();
    } else {
      param = `UserName=${this.commonService.getSavedUserInfo()?.userPrincipalName},OfficeId=${officeInfo?.value.id}`;
    }
    this.commonService.getAgentListbasedOnOffice(param).subscribe((res: any) => {
      this.agentList = res;
      if (this.lastSearchedOfficeFlag) {
        this.agentSearchForm.controls['agentName'].setValue(this.commonService.getLastSearchAgentDetails()?.agentName);
        this.selectedAgent = true;
        this.disableClrBtn = false;
      }
      this.spinner.hide();

      if(this.isMobileDevice && this.commonService.responsiveAdminSearchClicked)
      {
        sessionStorage.removeItem('currentUrl');
        sessionStorage.removeItem('adminSearchData'); 
      }
      let searchedAgentData = sessionStorage.getItem('adminSearchData'); 
      if(searchedAgentData !== null  && !this.commonService.responsiveAdminSearchClicked && this.lastSearchedOfficeFlag)
      { 
        this.searchedAgent = true;
        this.searchByOffice = this.commonService.getLastSearchAgentDetails()?.officeName?.id !== undefined;
        this.onSearchEmit.emit(this.commonService.getLastSearchAgentDetails());
        let redirectUrl = sessionStorage.getItem('currentUrl');
        redirectUrl = redirectUrl?redirectUrl:'/portal/personal-info/photos';
        this.commonService.redirectToNewPage(redirectUrl);        
      }      
    }, (_err: any) => {
      this.spinner.hide();
    })
  }

  /* search action */
  onSearch() {
    this.commonService.responsiveAdminSearchClicked = false;
    this.lastSearchedOffice = this.agentSearchForm.value;
    let isChanged = this.commonService.getFormUpdateStatus();
    if (isChanged) {
      this.confirmCancelModal.showModal('Are you sure you want to navigate away from this page?');
    } else {
      let userInfo = this.commonService.getSavedUserInfo();
      const data = this.agentSearchForm.value;
      if (userInfo !== undefined && userInfo.onPremisesSamAccountName.trimEnd().toString() === data?.agentName?.id?.trimEnd().toString() && this.commonService.isOfficeManagerUser()) {
        this.commonService.officeManagerAgentSearchClick$.next(false);
        this.commonService.setOfficeManagerAgentSitesClick(false);
        return;
      } else {
        this.commonService.setAgentNumber(data?.agentName?.id?.trimEnd());
        this.commonService.setLastAgentSearchDetails(data);
        sessionStorage.setItem('currentUrl','/portal/personal-info/photos');
        sessionStorage.setItem('adminSearchData', JSON.stringify(data));
        this.searchedAgent = true;
        this.spinner.show();
        this.commonService.setDelegateResponsiveFlag(false)
        this.onSearchEmit.emit(data);
      }
    }
  }

  onConfirmSearch() {
    this.commonService.setFormUpdateStatus(false);
    this.onSearch();
  }

  /* initialize search agent form */
  initializeSearchAgentForm() {
    if (this.isBranchAdminUser && this.branchAdminOfficeList?.length === 1) {
      this.agentSearchForm = this.formBuilder.group({
        agentName: new UntypedFormControl('', Validators.required),
      });
    } else {
      this.agentSearchForm = this.formBuilder.group({
        officeName: new UntypedFormControl('', Validators.required),
        agentName: new UntypedFormControl('', Validators.required),
      });
    }
  }

  /* On search by type change */
  onSearchByTypeChange(searchByOffice: boolean) {
    this.lastSearchedOfficeFlag = false;
    const officeNameControl = this.agentSearchForm.get('officeName');
    const agentNameControl = this.agentSearchForm.get('agentName');
    this.selectedAgent = false;
    this.disableClrBtn = true;
    if (!searchByOffice) {
      agentNameControl?.setValue({});
      agentNameControl?.setValidators([Validators.required]);
      officeNameControl?.setValue({});
      officeNameControl?.setValidators([]);
      agentNameControl?.updateValueAndValidity();
      officeNameControl?.updateValueAndValidity();
      this.getAgentList('');
      var searchedAgentData = JSON.parse(sessionStorage.getItem('adminSearchData') || '{}');
      if(Object.keys(agentNameControl?.value).length === 0)
      {
        this.agentSearchForm.controls['agentName'].setValue(searchedAgentData.agentName);
      }
    }
    this.searchByOffice = searchByOffice;

    if (this.searchByOffice) {
      officeNameControl?.setValue('');
      agentNameControl?.setValue('');
      officeNameControl?.setValidators([Validators.required]);
      agentNameControl?.setValidators([Validators.required]);
      agentNameControl?.updateValueAndValidity();
      officeNameControl?.updateValueAndValidity();
      if (this.officeList.length === 0) {
        this.getOfficelist();
      }
      if (officeNameControl?.value && Object.keys(officeNameControl.value).length === 0)
      {
        this.agentSearchForm.controls['officeName'].setValue(searchedAgentData?.officeName);
        if (officeNameControl?.value && Object.keys(officeNameControl.value).length !== 0) 
        {
          this.agentSearchForm.controls['agentName'].setValue(searchedAgentData?.agentName);
        }
      }
    }
  }

  /* On Clearing Search Values */
  onClear() {
    this.agentSearchForm.reset();
    this.selectedAgent = false;
    this.disableClrBtn = true;
    if (this.searchByOffice) {
      this.agentList = [];
      this.filteredAgentList = [];
    }
  }

  /**
   * filter office list autocomplete
   */
  filterOfficeList(event: any) {
    let filtered: any[] = [];
    let query = event.query?.split(' - ')[0];
    for (let i = 0; i < this.officeList?.length; i++) {
      let pfName = this.officeList[i];
      if (pfName.value.toLowerCase().startsWith(query.toLowerCase(), 0) || pfName.id.toLowerCase().startsWith(query.toLowerCase())) {
        filtered.push(pfName);
      }
    }
    this.filteredOfficeList = filtered;
    if (query.length > 0) {
      this.disableClrBtn = false;
    }
  }

  changeOfficeSelection(_event: any) {
    this.selectedAgent = false;
    this.disableClrBtn = false;
    this.agentList = [];
    this.filteredAgentList = [];
    this.agentSearchForm.controls['agentName'].setValue('');
  }

  /**
   * filter office list autocomplete
   */
  filterAgentList(event: any) {
    this.selectedAgent = false;
    let filtered: any[] = [];
    let query = (event.query)?.trim();

    if (this.isDelegateUser) {
      if(this.searchByOffice)
        this.agentList = this.getAgentList(this.agentSearchForm.controls['officeName'].value);
      else  this.agentList = this.delegateAgentList;
    }

    this.virtualLoading = query === '' && this.agentList?.length > 7;
    for (let i = 0; i < this.agentList?.length; i++) {
      let pfName = this.agentList[i];
      let dbaName = pfName.value.split('(')[1];
      if (pfName.value.toLowerCase().startsWith(query.toLowerCase(), 0) || pfName.id.startsWith(query, 0) || dbaName?.toLowerCase().startsWith(query.toLowerCase(), 0)) {
        filtered.push(pfName);
      }
    }
    this.filteredAgentList = filtered;
  }

  /* On selecting office */
  onSelectOffice(event: any) {
    if (event) {
      this.getAgentList(event);
      this.disableClrBtn = false;
    }
  }

  /** on select agent event */
  onSelectAgent() {
    this.selectedAgent = true;
    this.disableClrBtn = false;
  }



}
